module.exports = __webpack_public_path__ + "img/40_38_056_150.de86dbb2.jpg";